module.exports = {
    loadPage(setPageToLoad, pageId, requestInfo) {
        setPageToLoad(pageId, requestInfo)
    },
    pageRequestFailed(requestInfo, err) {
        if (requestInfo && requestInfo.errCallback) {
            requestInfo.errCallback(err)
        }
    }
}
